import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "tariffOptionsTable",
  class: "o-grid"
}
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y" }
const _hoisted_3 = { class: "u-form-heading unset-text-align" }
const _hoisted_4 = {
  key: 2,
  class: "o-grid"
}
const _hoisted_5 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 o-grid__cell--offset-3-480" }
const _hoisted_6 = { class: "o-grid o-grid--no-y-gutter o-grid--align-flex-end" }
const _hoisted_7 = { class: "o-grid__cell o-grid__cell--12" }
const _hoisted_8 = { class: "o-grid__cell o-grid__cell--9" }
const _hoisted_9 = { class: "c-list" }
const _hoisted_10 = { class: "o-grid o-grid--align-middle u-mar-t-2" }
const _hoisted_11 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 u-form-grid-nospace-y" }
const _hoisted_12 = {
  key: 4,
  class: "o-grid o-grid--align-middle u-mar-t-1"
}
const _hoisted_13 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 u-form-grid-nospace-y" }
const _hoisted_14 = { class: "c-form-control-checkbox gev19__contexthelp" }
const _hoisted_15 = {
  class: "c-form-control-checkbox__label",
  for: "buendelRabatt",
  style: {"max-width":"92%"}
}
const _hoisted_16 = { class: "c-form-control-checkbox__label-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_tarifauswahl_eine_linie = _resolveComponent("tarifauswahl-eine-linie")!
  const _component_leistungstabelle_eine_linie = _resolveComponent("leistungstabelle-eine-linie")!
  const _component_tarifoption_eine_linie = _resolveComponent("tarifoption-eine-linie")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_produktmodul_ausschluss = _resolveComponent("produktmodul-ausschluss")!
  const _component_produktmodul = _resolveComponent("produktmodul")!
  const _component_hug_rabatt = _resolveComponent("hug-rabatt")!
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_beitragFH = _resolveComponent("beitragFH")!
  const _component_email_oder_herunterladen = _resolveComponent("email-oder-herunterladen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      items: _ctx.navItems,
      active: 2,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      _createVNode(_component_tarifauswahl_eine_linie, { produktbezeichnung: _ctx.produktbezeichnung }, null, 8, ["produktbezeichnung"]),
      _createVNode(_component_leistungstabelle_eine_linie, {
        inhalt: _ctx.leistungen,
        link: _ctx.tibUrlEinProdukt,
        "link-fh-vgv": _ctx.tibUrlMultiProduktVgv,
        "link-fh-vhv": _ctx.tibUrlMultiProduktVhv
      }, null, 8, ["inhalt", "link", "link-fh-vgv", "link-fh-vhv"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.piniaStore.state.isMakler ? "Tarifmerkmale" : "Tarifoptionen"), 1)
        ])
      ]),
      _createVNode(_component_tarifoption_eine_linie, {
        tarifoptionInformation: _ctx.tarifoptionen[0],
        modelValue: _ctx.piniaStore.state.tarifinformationen.selbstbeteiligung,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.selbstbeteiligung) = $event)),
        modelModifiers: { number: true }
      }, null, 8, ["tarifoptionInformation", "modelValue"]),
      _createVNode(_component_tarifoption_eine_linie, {
        tarifoptionInformation: _ctx.tarifoptionen[1],
        modelValue: _ctx.piniaStore.state.tarifinformationen.sfr,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.sfr) = $event)),
        modelModifiers: { number: true }
      }, null, 8, ["tarifoptionInformation", "modelValue"]),
      _createVNode(_component_tarifoption_eine_linie, {
        tarifoptionInformation: _ctx.tarifoptionen[2],
        modelValue: _ctx.piniaStore.state.ferienhaus.vorschaedenVorhanden,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vorschaedenVorhanden) = $event)),
        modelModifiers: { number: true }
      }, null, 8, ["tarifoptionInformation", "modelValue"]),
      (_ctx.hatVorschaeden && _ctx.enthaeltVGV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_tarifoption_eine_linie, {
            key: 0,
            tarifoptionInformation: _ctx.tarifoptionen[3],
            modelValue: _ctx.piniaStore.state.ferienhaus.vgv.tarifinformationen.vorschaedenAnzahl,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vgv.tarifinformationen.vorschaedenAnzahl) = $event)),
            modelModifiers: { number: true }
          }, null, 8, ["tarifoptionInformation", "modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.hatVorschaeden && _ctx.enthaeltVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_tarifoption_eine_linie, {
            key: 1,
            tarifoptionInformation: _ctx.tarifoptionen[4],
            modelValue: _ctx.piniaStore.state.ferienhaus.vhv.tarifinformationen.vorschaedenAnzahl,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vhv.tarifinformationen.vorschaedenAnzahl) = $event)),
            modelModifiers: { number: true }
          }, null, 8, ["tarifoptionInformation", "modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.fehler.tarifoptionen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.tarifoptionen
                  }, null, 8, ["fehler-text"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.sollAusschlussZeigen())
        ? (_openBlock(), _createBlock(_component_produktmodul_ausschluss, {
            key: 3,
            "produktmodul-auschluss": _ctx.ausschlussModul
          }, null, 8, ["produktmodul-auschluss"]))
        : _createCommentVNode("", true),
      _createVNode(_component_produktmodul, {
        produktmodule: _ctx.produktmodule,
        "zeige-icons": true
      }, {
        vhvElementarHinweis: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", {
                class: _normalizeClass(["c-list__item", { 'c-list--inactive': _ctx.piniaStore.state.zuersZone.zone === '4' }])
              }, _toDisplayString(_ctx.ueberschwemmungText), 3),
              _cache[7] || (_cache[7] = _createElementVNode("li", { class: "c-list__item" }, "Erdsenkung, Erdrutsch", -1))
            ])
          ])
        ]),
        _: 1
      }, 8, ["produktmodule"]),
      _createElementVNode("div", _hoisted_10, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y" }, [
          _createElementVNode("h2", { class: "u-form-heading unset-text-align" }, "Rabatte")
        ], -1)),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_hug_rabatt)
        ])
      ]),
      (_ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y" }, null, -1)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.vhv.tarifinformationen.buendelRabatt) = $event)),
                  id: "buendelRabatt",
                  name: "buendelRabatt",
                  class: "c-form-control-checkbox__input",
                  type: "checkbox",
                  tabindex: "0",
                  "aria-label": "Bündelrabatt",
                  "aria-describedby": "tariffDiscountHuG",
                  role: "checkbox",
                  value: true,
                  "data-cy": "buendelRabatt"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.piniaStore.state.ferienhaus.vhv.tarifinformationen.buendelRabatt]
                ]),
                _createElementVNode("label", _hoisted_15, [
                  _createVNode(_component_icon_sprite, {
                    "icon-name": "icon-check-mark",
                    "css-klassen": "c-form-control-checkbox__icon",
                    "ist-klein": true
                  }),
                  _createElementVNode("span", _hoisted_16, [
                    _createTextVNode(_toDisplayString(_ctx.piniaStore.state.isMakler === true
                  ? "Der Versicherungsnehmer besitzt bereits eine GEV Wohngebäude-Versicherung für dieselbe Anschrift "
                  : "Ja, ich habe bereits eine GEV Wohngebäude-Versicherung für dieselbe Anschrift "), 1),
                    _cache[9] || (_cache[9] = _createElementVNode("strong", null, "(25% Rabatt)", -1))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_beitragFH, { onNextPage: _ctx.nextPage }, null, 8, ["onNextPage"]),
      _createVNode(_component_email_oder_herunterladen, {
        produkt: "fh",
        "tracking-zusatz": "tarif"
      })
    ])
  ], 64))
}